import * as React from 'react';

const AccordionContext = React.createContext('');
export const useAccordionCtx = () => React.useContext(AccordionContext);

const AccordionProvider = ({ children }) => {
  const [value, setValue] = React.useState('');
  return <AccordionContext.Provider value={{ value, setValue }}>{children}</AccordionContext.Provider>;
};

export default AccordionProvider;
